import { THistory } from "../../../services/api/instances/responseApi/types/response";

export const getDeltaHistory = (
  previousLength: number,
  currentHistory: THistory[],
): THistory[] => {
  if (currentHistory?.length <= previousLength || !currentHistory) {
    return [];
  }

  return currentHistory.slice(previousLength);
};

export const formatDeltaToMarkdown = (newItems: THistory[]): string => {
  if (newItems?.length === 0) return "";

  return newItems
    .map((item) => {
      const jsonStr = JSON.stringify(item, null, 2);
      return `\`\`\`json\n${jsonStr}\n\`\`\``;
    })
    .join("\n\n");
};
